import { render, staticRenderFns } from "./AdvisorClientMain.vue?vue&type=template&id=a3125660&scoped=true"
import script from "./AdvisorClientMain.vue?vue&type=script&lang=js"
export * from "./AdvisorClientMain.vue?vue&type=script&lang=js"
import style0 from "./AdvisorClientMain.vue?vue&type=style&index=0&id=a3125660&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3125660",
  null
  
)

export default component.exports